<template>
  <article class="resource-list-item" @click="onClickHandler">
    <a href="javascript:;" target="_blank">
      <div class="card-content">
        <div class="media">
          <div class="media-left">
            <figure class="resource-image image">
              <img :src="image" :alt="title">
            </figure>
          </div>
          <div class="media-content">
            <h5 class="resource-title">{{ title }}</h5>
          </div>
        </div>
      </div>
    </a>
  </article>
</template>

<script>
import ManualService from '@/services/ManualService'

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    externalUrl: {
      type: String,
      required: false
    },
    onClick: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    onClickHandler () {
      if (this.externalUrl) {
        this.onClick(this.externalUrl)
      } else {
        const win = window.open()
        ManualService.getResource(this.id).then((resource) => {
          win.opener = null
          win.location = resource.url
        })
      }
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.resource-list-item {
  border-bottom: 1px solid lightgray;
  cursor: pointer;

  .resource-image {
    width: 8rem;
    height: 8rem;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .resource-title {
    margin-bottom: .5rem;
    @include text-size-l();
    font-weight: 600;
    color: $color-text-dark;
  }

  .resource-type {
    float: right;
    text-align: center;

    .tag {
      color: $color-brand-secondary;
      font-weight: $font-weight-regular;
    }

    .resource-type-image {
      max-width: 2.5rem;
    }
  }

  .resource-tag {
    margin-bottom: .5rem;
  }

  &:hover {
    background-color: $color-gray-lighter;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ManualResourceListItem.vue